/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Notification_Bell_Label_OtherInputs */



/**
* | output |
* | --- |
* | "{count} new notifications" |
*
* @param {Notification_Bell_Label_OtherInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notification_bell_label_other = /** @type {((inputs: Notification_Bell_Label_OtherInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notification_Bell_Label_OtherInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} neue Benachrichtigungen`)
	return /** @type {LocalizedString} */ (`${i?.count} new notifications`)
});